module.exports = __webpack_public_path__ + "static/media/mojor.a5997281.jpg";